

  <div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Add money to wallet</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
    <mat-dialog-content style="padding-bottom: 0px;padding-top: 10px;">
  <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input matInput smDecimalOnly (ngModelChange)="onAmountChange($event)"
        type="number" [(ngModel)]="amount"/>
      </mat-form-field>
    </div>
<div>
       <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Notes</mat-label>
          <textarea [(ngModel)]="notes" matInput></textarea>
        </mat-form-field>
</div>

<div class="money_description_open">
  <p>Add wallet money to promote your business or for any cancellation/deleted booking purpose.</p>
</div>

 <div
    
    class="add_crt"
    style="display: flex; gap: 20px; margin-bottom: 20px; margin-top: 25px"
  >
    <div class="try">
      <mat-checkbox [(ngModel)]="notify" (change)="onNotifyChange($event)"></mat-checkbox>
      <label
        style="margin-left: 10px; position: relative; top: -3px"
        for="testing1"
        class="check-label"
        >Notify customer/member via WhatsApp and Email.</label
      >
    </div>
  </div>

  <div *ngIf="notify">
       <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Custom message</mat-label>
          <textarea [(ngModel)]="cmsg" matInput></textarea>
        </mat-form-field>
</div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent" (click)="onsave()" [disabled]="!amount">Add</button>
</mat-dialog-actions>